import { TextArea, TextField } from '@heroui/react';

// 贴 TDesign Textarea 心智的多行输入封装,收敛 TextField + TextArea 两层结构
export function SimpleTextArea({
  value,
  onChange,
  placeholder,
  className,
  maxLength,
  rows = 3,
  isDisabled,
  'aria-label': ariaLabel,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  maxLength?: number;
  rows?: number;
  isDisabled?: boolean;
  'aria-label'?: string;
}) {
  return (
    <TextField
      aria-label={ariaLabel ?? placeholder ?? '输入'}
      className={className}
      value={value}
      onChange={onChange}
      isDisabled={isDisabled}
    >
      <TextArea
        fullWidth
        className="resize-y"
        placeholder={placeholder}
        maxLength={maxLength}
        rows={rows}
      />
    </TextField>
  );
}
